/*
  import { archReqCategories } from '@/services/Architectural/ArchitecturalCategory/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'

import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await archReqCategories.dispatch ('List', {
      hoaId
    });
  */
  async List({}, { hoaId }) {
    try {
      const result = await kms.get('/Architectural/ArchitecturalCategory/List', {
        params: {
          hoaId
        }
      })

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The architectural category list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const archReqCategories = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
